import tippy from "tippy.js";

export default function initPopups() {
    tippy('[data-tippy-content]', {
        hideOnClick: false,
    });
}
